export const LAYOUT_HEADER_ADD_ENTITY_BUTTON_OPTION_VALUE = {
  buildingGroup: 'buildingGroup',
  docFlow: 'docFlow',
  email: 'email',
  file: 'file',
  post: 'post',
  serviceRequest: 'serviceRequest',
}
